import { LoadingButton } from '@mui/lab';
import { Button, TextField } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import MyToastShow from '@/components/Layout/MyToast';
import { useState } from 'react';
import { IUser } from '@/redux/models';


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '55%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    p: 3,

};


export default function ModalEliminarUsuario({ open, onClose, user, eliminarUsuario }: { open: boolean, onClose: () => void, user: IUser, eliminarUsuario: (id: number, code: string) => Promise<void> }) {

    const [code, setCode] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)

    const handleClose = () => {
        setCode('')
        onClose()
    }

    const handleEliminarUsuario = () => {
        setLoading(true)
        eliminarUsuario(user.id, code).then(() => {
            MyToastShow({ message: 'Usuario eliminado correctamente', type: 'success', autoClose: 1500 })
            handleClose()
        }).catch((error: any) => {
            MyToastShow({ message: error?.data?.message || 'Error al eliminar el usuario', type: 'error', autoClose: 1500 })
        }).finally(() => setLoading(false))
    }


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: {
                        enter: 700,
                        appear: 500,
                        exit: 300,
                    }
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <Typography id="transition-modal-title" variant="h6" component="h2">
                        Eliminar
                    </Typography>
                    <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                        ¿Está seguro que desea eliminar el usuario {user.nombre}?
                    </Typography>
                    <TextField fullWidth label="Código de confirmación" variant="outlined" sx={{ mt: 2 }}
                        value={code}
                        onChange={(e) => setCode(e.target.value)} />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button onClick={handleClose} sx={{ mr: 2 }}>Cerrar</Button>
                        <LoadingButton
                            loading={loading}
                            onClick={handleEliminarUsuario}
                            variant="contained"
                            color="error">
                            Eliminar
                        </LoadingButton>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}
